import createHostComponent from '../../createHostComponent';
import defaults from './props/default';
var Navigator = createHostComponent('navigator', null, defaults);
export default Navigator;
